import React, { useState, useEffect } from "react";
import Product from "../components/Product";
import FilterModalSolutions from "../components/FilterModalSolutions";
import { Row, Col, Button, Container } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import InfiniteScroll from "react-infinite-scroll-component";

import Meta from "../components/Meta";

import { useDispatch, useSelector } from "react-redux";
import { listProducts } from "../actions/productActions";

function SolutionScreen({ match, history }) {
  const [visibleProducts, setVisibleProducts] = useState(12);
  const threeMothsAgo = new Date();
  threeMothsAgo.setMonth(threeMothsAgo.getMonth() - 15);
  const timestamp = threeMothsAgo.toISOString();
  const [type, setType] = useState("");
  const [FilteredValues, setFilteredValues] = useState([]);
  const [specificCategory, setspecificCategory] = useState("");
  const [specificValue, setspecificValue] = useState("");
  const [solutionProducts, setSolutionProducts] = useState([]);

  const dispatch = useDispatch();
  const productList = useSelector((state) => state.productList);
  const { loading, error, products } = productList;

  const loadMore = () => {
    setTimeout(() => {
      // Simulate loading delay with setTimeout
      setVisibleProducts((prevVisibleProducts) => prevVisibleProducts + 12); // Increment the number of visible products
    }, 1000); // Wait for 1 second before loading more products
  };

  const filterProducts = (products, FilteredValues) => {
    const { PriceRange, brand, solutionQuantity } = FilteredValues;

    let minPrice;
    let maxPrice;

    if (PriceRange === 0) {
      minPrice = 0;
      maxPrice = 10000000;
    } else {
      minPrice = (PriceRange - 1) * 100;
      maxPrice = PriceRange * 100;
    }

    return products.filter((product) => {
      if (product.price <= minPrice || product.price >= maxPrice) {
        return false;
      }

      if (brand && product.brand !== brand) {
        return false;
      }

      if (solutionQuantity && product.solutionQuantity !== solutionQuantity) {
        return false;
      }

      return true;
    });
  };

  useEffect(() => {
    dispatch(listProducts());
  }, [dispatch]);

  useEffect(() => {
    // Filter products by category 'Solution' whenever the products array changes
    if (products) {
      const filteredProducts = products.filter(
        (product) => product.category === "Solution"
      );
      setSolutionProducts(filteredProducts);
    }
  }, [products]);

  useEffect(() => {
    if (match && match.params && match.params.value) {
      const data = match.params.value.split("-");
      setspecificCategory(data[0]);
      setspecificValue(data[1]);
      setType("specific");
    } else {
      setType("All");
    }
  }, [match.params.value, match]);

  return (
    <>
      <Meta />

      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Row>
            <Col md={12}>
              <div
                className=' position-relative bg-image bg-overlay-60'
                style={{
                  backgroundImage: `url("../../staticuploads/ScreenPic6.jpg")`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  animation: " moveBackground 10s ease-in-out infinite",
                  transformOrigin: "center center",
                }}
              >
                <Row>
                  <Col md={{ span: 3, offset: 1 }}>
                    <div
                      style={{ textAlign: "center", marginTop: "5rem" }}
                      className=' position-relative z-index-1 '
                    >
                      <h1
                        style={{ textAlign: "justify" }}
                        className='display-4  text-white'
                      >
                        Find The{" "}
                        <strong style={{ color: "#ffff03" }}>Best </strong>
                        <strong style={{ color: "#2f99d1" }}>Solution </strong>
                        For
                        <strong style={{ color: "green" }}> Yourself </strong>
                        <strong style={{ color: "red" }}> Now </strong>
                      </h1>
                      <Button
                        className='mt-1 mb-5 shadow rounded'
                        type='Button'
                        onClick={() => history.push(`/solution`)}
                      >
                        SEE MORE
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Container className='mt-3'>
            {type === "BestRatedWithValue" && (
              <h1 id='pro' className='text-center'>
                <Button
                  className=' buts shadow btn-light rounded'
                  type='button'
                  onClick={() => setType("specific")}
                >
                  {`All ${specificValue} Solutions`}
                </Button>
              </h1>
            )}
            {match.params.value ? (
              type === "BestRatedWithValue" ? (
                <></>
              ) : (
                <h1 id='pro' className='text-center'>
                  <Button
                    className=' buts shadow btn-light rounded'
                    type='button'
                    onClick={() => setType("BestRatedWithValue")}
                  >
                    {`Best Rated ${specificValue} Solutions`}
                  </Button>
                </h1>
              )
            ) : (
              <h1 id='pro' className='text-center'>
                <Button
                  className=' buts shadow btn-light rounded'
                  type='button'
                  onClick={() => setType("All")}
                >
                  ALL
                </Button>{" "}
                <Button
                  className=' buts shadow btn-light rounded'
                  type='button'
                  onClick={() => setType("NewArrivals")}
                >
                  NEW ARRIVALS
                </Button>{" "}
                <Button
                  className='buts shadow btn-light rounded'
                  type='button'
                  onClick={() => setType("Popular")}
                >
                  POPULAR
                </Button>
              </h1>
            )}
            <h2 className='text-end'>
              <FilterModalSolutions
                Existingvalue={match}
                FilteredValues={FilteredValues}
                setFilteredValues={setFilteredValues}
                setType={setType}
                products={solutionProducts}
                type={type}
              />
            </h2>
            <hr></hr>
            {type === "All" && (
              <InfiniteScroll
                dataLength={visibleProducts}
                next={loadMore}
                hasMore={visibleProducts < solutionProducts.length}
                // loader={<Loader />}
              >
                <Row>
                  <h4>Our Wide Range Of Solutions</h4>
                  {solutionProducts.slice(0, visibleProducts).map((product) => (
                    <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                      <Product product={product} />
                    </Col>
                  ))}
                </Row>
              </InfiniteScroll>
            )}

            {type === "Popular" && (
              <Row>
                <h4>Popular Solutions</h4>
                {solutionProducts
                  .filter((product) => product.numReviews >= 200)
                  .map((product) => (
                    <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                      <Product product={product} />
                    </Col>
                  ))}
              </Row>
            )}
            {type === "NewArrivals" && (
              <Row>
                <h4>Newly Arrived Solutions</h4>
                {solutionProducts
                  .filter(
                    (product) =>
                      new Date(product.createdAt) > new Date(timestamp)
                  )
                  .map((product) => (
                    <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                      <Product product={product} />
                    </Col>
                  ))}
              </Row>
            )}
            {type === "BestRatedWithValue" &&
              ((specificCategory === "brand" && (
                <Row>
                  <h4>{`Best Rated ${specificValue} Solutions`}</h4>
                  {solutionProducts
                    .filter((product) => product.brand === `${specificValue}`)
                    .sort((a, b) => b.rating - a.rating)
                    .slice(0, 5)
                    .map((product) => (
                      <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                        <Product product={product} />
                      </Col>
                    ))}
                </Row>
              )) ||
                (specificCategory === "solutionQuantity" && (
                  <Row>
                    <h4>{`Best Rated ${specificValue} Solutions`}</h4>
                    {solutionProducts
                      .filter(
                        (product) =>
                          product.solutionQuantity === `${specificValue}`
                      )
                      .sort((a, b) => b.rating - a.rating)
                      .slice(0, 5)
                      .map((product) => (
                        <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                          <Product product={product} />
                        </Col>
                      ))}
                  </Row>
                )))}
            {type === "specific" &&
              ((specificCategory === "brand" && (
                <Row>
                  <h4>{`All ${specificValue} Solutions`}</h4>
                  {solutionProducts
                    .filter((product) => product.brand === `${specificValue}`)
                    .map((product) => (
                      <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                        <Product product={product} />
                      </Col>
                    ))}
                </Row>
              )) ||
                (specificCategory === "solutionQuantity" && (
                  <Row>
                    <h4>{`All ${specificValue} Solutions`}</h4>
                    {solutionProducts
                      .filter(
                        (product) =>
                          product.solutionQuantity === `${specificValue}`
                      )
                      .map((product) => (
                        <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                          <Product product={product} />
                        </Col>
                      ))}
                  </Row>
                )))}
            {type === "Filter" && (
              <Row>
                <h4>Filtered Solutions</h4>
                {filterProducts(solutionProducts, FilteredValues).map(
                  (product) => (
                    <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                      <Product product={product} />
                    </Col>
                  )
                )}
                {filterProducts(solutionProducts, FilteredValues).length ===
                  0 && <h1>Sorry, No product Found</h1>}
              </Row>
            )}
            <hr></hr>
          </Container>
        </>
      )}
    </>
  );
}
export default SolutionScreen;
